import type { DemCloudTalkFilter } from '../../types/dem';
import type { CloudTalkAgentStatusTone } from '../../lib/demCloudTalk';

type CloudTalkFilterRowProps = {
  label: string;
  status?: string;
  /** Shown under / beside status when agent belongs to more groups. */
  badge?: string;
  title?: string;
  selected: boolean;
  tone?: 'danger' | 'default' | 'muted';
  statusDot?: CloudTalkAgentStatusTone;
  onSelect: () => void;
};

export function CloudTalkFilterRow({
  label,
  status,
  badge,
  title,
  selected,
  tone = 'default',
  statusDot,
  onSelect,
}: CloudTalkFilterRowProps) {
  return (
    <button
      type="button"
      className={`dem-cloudtalk-filter-row dem-cloudtalk-filter-row--${tone}${selected ? ' dem-cloudtalk-filter-row--selected' : ''}`}
      aria-pressed={selected}
      title={title || label}
      onClick={onSelect}
    >
      <span className="dem-cloudtalk-filter-row__name dem-customer-cell--clip" title={title || label}>
        {statusDot ? (
          <span
            className={`dem-cloudtalk-filter-row__dot dem-cloudtalk-filter-row__dot--${statusDot}`}
            aria-hidden
          />
        ) : null}
        {label}
      </span>
      <span className="dem-cloudtalk-filter-row__meta">
        {badge ? <span className="dem-cloudtalk-filter-row__badge">{badge}</span> : null}
        {status ? (
          <span className={`dem-cloudtalk-filter-row__status dem-cloudtalk-filter-row__status--${tone}`}>
            {status}
          </span>
        ) : (
          <span className="dem-cloudtalk-filter-row__status" aria-hidden />
        )}
      </span>
    </button>
  );
}

export type { DemCloudTalkFilter };
